<template>
  <div></div>
</template>
<script>
export default {
  created() {
    window.location.href = "https://teleportal.net/news";
  }
};
</script>
